import { Component, OnInit, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/service/auth/auth.service';
import { HomeService } from 'src/app/service/common/home.service';
import { Permission, UserType } from 'src/app/service/common/interface';


@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit, OnDestroy {

  private routerSubscription: Subscription;

  searchData : {
    filter : string,
    tableName : string
  } = {
    filter : '',
    tableName : 'cases'
  }
  placeholder : string = "Search cases here.. eg. court ref, claiment, defendant."
  user : string = null;
  permission : Permission= {
    solicitorFirm : null,
    solicitor : null,
    barrister : null,
    case : null,
    archieved : null,
    client : null,
    court : null,
    conferrence : null,
    invoice : null,
    report : null,
    user : null,
    permission : null,
    setting : null,
    holiday : null,
    document : null,
    notes : null,
    diary : null,
    dashboard : null
  };
  userType : UserType = null;
  models : any;
  isSearchOpen : boolean = false;
  isMobileMenuOpen : boolean = false;
  isNavMenuOpen : boolean = false;
  isLoginPage : boolean = false;

  constructor(
    private auth : AuthService,
    private homeService : HomeService,
    private router : Router,
    private eRef: ElementRef
  ) {
    this.user = this.auth.getUserName();
  }

  ngOnInit(): void {
    // Subscribe to router events to hide nav on login pages
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Hide nav on login routes
        this.isLoginPage = event.url.startsWith('/auth/login') || event.url === '/auth/login';
        // Close search dropdown and nav menu on navigation
        this.isSearchOpen = false;
        this.isNavMenuOpen = false;
        this.models = null;
        this.searchData.filter = '';
      }
    });

    if(this.auth.getPermission()){
      this.auth.getPermission().subscribe(res=>{
        this.permission = res;
        // console.log(this.permission);
      })
    }

    if(this.auth.getUserType()){
      this.auth.getUserType().subscribe(res=>{
        this.userType = res;
        // console.log(res);
      })
    }

    // Initialize placeholder
    this.updatePlaceholder();

  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }


  updatePlaceholder(){
    if(this.searchData.tableName == 'cases'){
      this.placeholder = 'Search cases here. e.g. court ref, claiment, defendant.';
    }else if(this.searchData.tableName == 'barristers'){
      this.placeholder = 'Search Barristers here.. eg. First Name, Last Name, Company Name, Company postcode, Email.';
    }else if(this.searchData.tableName == 'solicitorCompany'){
      this.placeholder = 'Search Solicitors here.. eg. Company Name, trading Name, address, Postcode.';
    }else if(this.searchData.tableName == 'clients'){
      this.placeholder = 'Search Clients here.. eg. First name, Last Name, address, postcode, mobile.';
    }else if(this.searchData.tableName == 'invoice'){
      this.placeholder = 'Search Invoice here.. eg. invoice Number ....';
    }
  }

  onSearchInput(event: any) {
    const value = event.target.value;
    this.searchData.filter = value;
    if (value && value.length >= 3) {
      this.homeService.searchNow(this.searchData).subscribe(res => {
        // console.log(res);
        this.models = res.data;
      });
    } else {
      this.models = null;
    }
  }

  searchNow(){
    if(this.searchData.filter && this.searchData.filter.length > 3){
      this.homeService.searchNow(this.searchData).subscribe(res => {
        // console.log(res);
        this.models = res.data;
      })
    }else{
      this.models = null;
    }
  }

  navigate(link){
    this.models = null;
    this.searchData.filter = '';
    this.isSearchOpen = false; // Close dropdown after navigation
    this.router.navigateByUrl(link);
  }

  tryLogOut(){
    this.auth.logOut();
  }

  toggleSearch(){
    this.isSearchOpen = !this.isSearchOpen;
    // Auto-focus the search input when opening
    if (this.isSearchOpen) {
      setTimeout(() => {
        const searchInput = document.querySelector('.search-dropdown input[name="filter"]') as HTMLInputElement;
        if (searchInput) {
          searchInput.focus();
        }
      }, 200);
    }
  }

  toggleNavMenu(){
    this.isNavMenuOpen = !this.isNavMenuOpen;
  }

  closeSearch(){
    this.isSearchOpen = false;
    this.models = null;
    this.searchData.filter = '';
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (this.isNavMenuOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.isNavMenuOpen = false;
    }
  }

}
